import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {ANumberConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ANumberConfig';

export class Size
{
    @Property<ANumber>({
        title: 'Width',
        tip: `Width`,
        isRequired: false,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    public readonly width:ANumber;

    @Property<ANumber>({
        title: 'Height',
        tip: `Height`,
        isRequired: false,
        typeConfig: ANumberConfig,
        typeCtor: ANumber
    })
    public readonly height:ANumber;

    public constructor(_width:number, _height:number)
    {
        this.width = ANumber.fromNumber(_width);
        this.height = ANumber.fromNumber(_height);
    }

    public static from(width:number, height:number):Size
    {
        return new Size(width, height);
    }

    public static zero():Size
    {
        return Size.from(0, 0);
    }

    toString()
    {
        return `${this.width.value}x${this.height.value}`;
    }
}
